import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-alerts-list',
  templateUrl: './view-alerts-list.component.html',
  styleUrls: ['./view-alerts-list.component.scss']
})
export class ViewAlertsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
